import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, Clock3, CheckCircle2, XCircle, Hourglass, Eye } from 'lucide-react';
import { useI18n } from '../i18n';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_META = {
  pending: { label: 'Pendiente', icon: Hourglass, cls: 'text-amber-400 border-amber-500/40 bg-amber-500/10' },
  reviewing: { label: 'En revisión', icon: Eye, cls: 'text-sky-400 border-sky-500/40 bg-sky-500/10' },
  accepted: { label: 'Seleccionado/a', icon: CheckCircle2, cls: 'text-emerald-400 border-emerald-500/40 bg-emerald-500/10' },
  rejected: { label: 'No seleccionado/a', icon: XCircle, cls: 'text-red-400 border-red-500/40 bg-red-500/10' },
};

export const StatusPill = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.pending;
  const Icon = meta.icon;
  return (
    <span data-testid={`application-status-${status}`} className={`inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-widest px-2.5 py-1 rounded-md border ${meta.cls}`}>
      <Icon size={12} /> {meta.label}
    </span>
  );
};

export const MyApplications = () => {
  const { locale } = useI18n();
  const [list, setList] = useState(null);
  useEffect(() => {
    fetch(`${API}/applications/me`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : []))
      .then(setList)
      .catch(() => setList([]));
  }, []);
  const fmt = (iso) => new Date(iso).toLocaleString(locale === 'ca' ? 'ca-ES' : locale === 'en' ? 'en-GB' : 'es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

  return (
    <div className="sc-card p-6 md:p-8 mb-6" data-testid="my-applications-card">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <div className="flex items-center gap-2">
          <Briefcase size={14} className="text-amber-500" />
          <h2 className="sc-mono-eyebrow text-amber-500">Mis candidaturas</h2>
        </div>
        {list && <span className="text-[11px] font-mono uppercase tracking-widest text-slate-500">{list.length} enviadas</span>}
      </div>
      {list === null && <div className="w-6 h-6 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />}
      {list && list.length === 0 && (
        <div className="text-sm text-slate-400" data-testid="applications-empty">
          Aún no has enviado ninguna candidatura. <Link to="/ofertas" className="text-amber-500 hover:underline">Ver ofertas →</Link>
        </div>
      )}
      {list && list.length > 0 && (
        <div className="divide-y divide-[#2A2F3D]">
          {list.map((a) => (
            <div key={a.id} data-testid={`application-${a.job_id}`} className="py-4 flex flex-col sm:flex-row sm:items-center gap-3">
              <div className="flex-1 min-w-0">
                <Link to={`/ofertas/${a.job_id}`} className="text-sm font-semibold text-white hover:text-amber-500 transition-colors block truncate" style={{ fontFamily: 'Outfit, sans-serif' }}>{a.job_title}</Link>
                <div className="text-[11px] text-slate-500 font-mono uppercase tracking-wider mt-1 flex items-center gap-2 flex-wrap">
                  <span>{a.company_name}</span>
                  <span className="text-slate-700">·</span>
                  <span className="inline-flex items-center gap-1"><Clock3 size={11} /> {fmt(a.created_at)}</span>
                </div>
              </div>
              <StatusPill status={a.status} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyApplications;
